import ForecastDetailsNew from "../components/ForecastDetailsNew";

const ForecastDetailsNewPage = () => {
    return (
        <ForecastDetailsNew />
    );
};

export default ForecastDetailsNewPage;